import { makeStyles } from "@material-ui/core"

export const tenantListStyles = makeStyles((theme) => ({
    tenantList: {
        padding: '0 1em'
    },
    tenantCard: {
        padding: '1.5em'
    },
    pageTitle: {
        fontSize: '1.3em',
    },
    resetButton: {
        marginLeft: '1em',
    }
}));